import app from 'flarum/forum/app';
import addKnowledgeBase from './addKnowledgeBase';
import addTickets, { addTicketNotificationSettings } from './addTickets';
export { default as extend } from './extend';
app.initializers.add('soup-97-support', () => {
  addKnowledgeBase();
  addTickets();
  addTicketNotificationSettings();
});